





















import { defineComponent, computed } from '@vue/composition-api';

import {
  getSubdistricts,
} from '@/api';

const CommonSubdistrictSelector = defineComponent({
  props: {
    level: {},
    label: {
      type: String,
      default() { return 'ตำบล'; },
    },
    value: {
      type: [Object],
      default() { return null; },
    },
    showLabel: { default: false },
    rules: { default: '' },
    districtId: { default: -1 },
    showAsEnglish: { default: false },
  },
  setup(props: any) {
    const getSubdistrictsResult = (data: any) => data;

    const _value = computed(() => props.value);

    return {
      getSubdistricts,
      getSubdistrictsResult,
      _value,
    };
  },
});

export default CommonSubdistrictSelector;
